// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Admin } from './admin';
import { AdminTypeHistory } from './admin-type-history';
import { AppointmentMethod } from './appointment-method';
import { Counterparty } from './counterparty';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class AdminAppointmentMethod extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  adminAppointmentMethodId!: number;
  applicant?: string;
  appointmentMethodId!: number;
  courtName?: string;
  courtOrderDate?: Date;
  courtProceedingMatterNo?: string;
  courtProceedingYear?: string;
  createdBy!: string;
  createdDate!: Date;
  data?: string;
  insolvencyProceedings?: string;
  instAppointeeCounterparty?: number;
  instApptDate?: Date;
  instDate?: Date;
  instDescription?: string;
  instRegChargeNo?: string;
  instRegisteredIn?: string;
  isSubjectToProceedings!: boolean;
  lodgeDate?: Date;
  lodgeTime?: Date;
  lookupId1?: number;
  lookupId2?: number;
  lookupId3?: number;
  lookupId4?: number;
  lookupId5?: number;
  memo?: string;
  notice?: string;
  otherApptDate?: Date;
  securedCreditorId?: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  adminTypeHistories!: AdminTypeHistory[];
  admins!: Admin[];
  appointmentMethod!: AppointmentMethod;
  instAppointeeCounterpartyNavigation!: Counterparty;
}

